import { render, staticRenderFns } from "./AcessoNegado.vue?vue&type=template&id=254590dc&"
import script from "./AcessoNegado.vue?vue&type=script&lang=js&"
export * from "./AcessoNegado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports